import axios, { AxiosInstance } from 'axios'

let apiInstance: AxiosInstance

type AxiosInstanceFactoryArgTypes = {
  url: string
  token: string
  headers?: { [key: string]: any }
}

export function apiInstanceFactory({
  url,
  token,
  headers,
}: AxiosInstanceFactoryArgTypes) {
  if (!url) {
    throw new Error('[apiInstanceFactory]: url argument not provided')
  }

  if (!token) {
    throw new Error('[apiInstanceFactory]: token argument not provided')
  }

  apiInstance = axios.create({
    baseURL: url,
    headers: {
      Accept: 'application/json, text/plain, */*',
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...headers,
    },
  })

  return apiInstance
}

export { apiInstance }
